import { notificationStrings, API_DOMAIN, TOKEN_URL } from '@constants/app-constants';
import { call, put, takeEvery } from 'redux-saga/effects';
import Actions from '../action';
import Axios from 'axios';
import { message } from 'antd';
import { openNotificationWithIcon } from '@sharedComponent/notification-message/notification';

export function* getOpportunityInfoServiceWorker(action) {
	try {
		let opportunityId = action.optId;
		const uri = `${API_DOMAIN}/Opportunity/` + opportunityId;
		let res = yield call(Axios.get, uri);
		yield put(Actions.creators.getOpportunityInfoSuccess(res));
		localStorage.setItem('companyId', res.data.opportunity.companyViewModel.companyId);
		// localStorage.setItem('branchId', res.data.opportunity.companyViewModel.branchId);
		let companyId = localStorage.getItem('companyId');
		if (action.isLandingPageClick) {
			if (res.data.opportunity.companyViewModel.currentScreenName === 'Summary') {
				action.history.push(`/user/contactinfo/3`);
			} else if (res.data.opportunity.companyViewModel.currentScreenName === 'Contact') {
				action.history.push(`/user/contactinfo/1`);
			} else if (res.data.opportunity.companyViewModel.currentScreenName === 'Card Delivery Address') {
				action.history.push(`/user/contactinfo/2/${companyId}`);
			}
			// else if (res.data.opportunity.companyViewModel.currentScreenName === 'UnEmploymentInsurance') {
			// 	action.history.push(`/user/contactinfo/4`);
			// }
			else {
				action.history.push(`/user/companyinfo/${companyId}`);
			}
		}
	} catch (err) {
		openNotificationWithIcon(notificationStrings.error, 'Internal server error.');
		yield put(Actions.creators.getOpportunityInfoError());
	}
}
export function* getTokenWorker() {
	try {
		const params = new URLSearchParams();
		// TODO : Need to update configuration in pipeline library
		params.append('client_id', '549af87db51544d99d7d68aacdc2bec8');
		params.append('client_secret', 'LYi16CbzGfS6wRDHgfYrVoLrudK1WvRQd1TY6A5s');
		params.append('grant_type', 'client_credentials');
		params.append('scope', 'erae-onboarding-api');
		params.append('acr_values', 'tenant:ae');
		const url = TOKEN_URL;
		const res = yield call(Axios.post, url, params);
		yield put(Actions.creators.getTokenActionSuccess(res.data));
	} catch (e) {
		message.error('Network error.');
	}
}

export default function* opportunityWatcher() {
	yield takeEvery(Actions.types.GET_OPPORTUNITY_DATA_START, getOpportunityInfoServiceWorker);
	yield takeEvery(Actions.types.GET_TOKEN_START, getTokenWorker);
}
